import { CommonModule } from '@angular/common';
import { CustomizeCascaderComponent } from './customize-cascader.component';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { NzCascaderModule } from 'ng-zorro-antd/cascader';

@NgModule({
    declarations: [CustomizeCascaderComponent],
    imports: [CommonModule, FormsModule, NzCascaderModule],
    exports: [CustomizeCascaderComponent],
})
export class CustomizeCascaderModule {}
